import type { Translations } from "../types";

const ms: Translations = {
  "meta.title": "Klik mengikut Peta Negara",
  "meta.description":
    "Peta dunia interaktif: klik percuma bagi setiap negara serta sokongan berbayar melalui Stripe, PayPal dan Buy Me a Coffee.",

  "app.title": "Klik mengikut Peta Negara",

  "map.intro":
    "Klik sesebuah negara pada peta untuk memberikan undi percuma, atau hantar sokongan kewangan - kedua-duanya dikira dalam papan pendahulu gabungan di bawah. Peta ini hanya mencerminkan sokongan dalam aplikasi ini, bukan kekayaan negara atau KDNK sebenar.",
  "map.verifying": "Mengesahkan …",
  "map.confirmNotRobot": "Sebelum anda boleh menambah klik percuma, sahkan dahulu bahawa anda bukan robot:",
  "map.tryAgain": "Cuba lagi",
  "map.registeringClick": "Mendaftarkan klik …",
  "map.selectedCountry": "Negara dipilih: {name}.",
  "map.selectFirstFeedback": "Negara telah dipilih. Untuk menambah klik percuma, sahkan dahulu di bawah bahawa anda bukan robot.",
  "map.verificationExpired": "Pengesahan telah tamat tempoh - sahkan semula bahawa anda bukan robot.",
  "map.slowDown": "Perlahan sikit - tunggu sebentar sebelum klik seterusnya.",
  "map.clickFailed": "Klik tidak dapat didaftarkan. Sila cuba lagi.",
  "map.clickErrorGeneric": "Ralat semasa mendaftarkan klik.",
  "map.leaderboardHeading": "Papan Pendahulu Negara",
  "map.emptySelection": "Pilih negara pada peta untuk mengklik atau menyokongnya.",
  "map.loadingData": "Memuatkan data …",

  "worldmap.loadError": "Peta tidak dapat dimuatkan.",
  "worldmap.resetZoom": "Set semula zum",
  "worldmap.resetButton": "⤾ Set semula",
  "worldmap.loadingMap": "Memuatkan peta …",
  "worldmap.unknownCountry": "Tidak diketahui",
  "worldmap.ariaClicks": "{name}: {clicks} klik",
  "worldmap.tooltipClicks": "{clicks} klik",

  "legend.fewer": "Klik lebih sedikit",
  "legend.more": "Klik lebih banyak",

  "list.empty": "Belum ada klik. Jadilah yang pertama!",
  "list.ariaLabel": "Papan pendahulu negara mengikut klik",

  "human.siteKeyMissing": "VITE_TURNSTILE_SITE_KEY tidak ditetapkan - rujuk README untuk konfigurasi.",
  "human.verificationFailedGeneric": "Pengesahan gagal.",
  "human.networkError":
    "Tidak dapat menghubungi pengesahan (ralat rangkaian) - semak VITE_SUPABASE_URL, pastikan verify-human telah digunakan (deployed), dan ALLOWED_ORIGIN; rujuk README/NAVODILA.",
  "human.verificationFailedRetry": "Pengesahan gagal, sila cuba lagi.",

  "provider.stripe": "💳 Kad (Stripe)",
  "provider.paypal": "🅿️ PayPal",
  "provider.buymeacoffee": "☕ Buy Me a Coffee",

  "panel.selectedCountryLabel": "Negara dipilih",
  "panel.currentlyRanked": "Kedudukan semasa #{rank}",
  "panel.shareCopied": "Disalin ✓",
  "panel.shareShared": "Dikongsi ✓",
  "panel.shareButton": "🔗 Kongsi",

  "panel.tableClicks": "Klik",
  "panel.tableFree": "Percuma",
  "panel.tablePaid": "Berbayar",
  "panel.rowAllTime": "Sepanjang masa",
  "panel.rowThisYear": "Tahun ini",
  "panel.rowThisWeek": "Minggu ini",
  "panel.rowToday": "Hari ini",

  "panel.totalCombined": "Jumlah gabungan:",
  "panel.totalSupport": "Jumlah sokongan:",

  "panel.paymentMethod": "Kaedah pembayaran",
  "panel.noPaymentMethod": "Tiada kaedah pembayaran yang tersedia buat masa ini.",
  "panel.supportAmount": "Jumlah sokongan (EUR)",
  "panel.amountRange": "Jumlah hendaklah antara {min} dan {max}.",
  "panel.quickAmount": "{eur} €",
  "panel.estimatedClicks": "Anggaran klik berbayar:",
  "panel.ratioInfo":
    "Nisbah: {a} = {b} klik (cth. {c} = {d} klik). Ini hanya anggaran sebelum pembayaran - kiraan klik akhir sentiasa dikira dan disahkan oleh pelayan berdasarkan pembayaran yang benar-benar disahkan.",
  "panel.preparing": "Menyediakan …",
  "panel.continueWith": "Teruskan dengan {provider}",
  "panel.choosePaymentMethod": "Pilih kaedah pembayaran",
  "panel.bmcUsernameMissing": "VITE_BMC_USERNAME tidak ditetapkan - rujuk README untuk konfigurasi.",
  "panel.paypalClientIdMissing": "VITE_PAYPAL_CLIENT_ID tidak ditetapkan - rujuk README untuk konfigurasi.",

  "panel.paypalAmountInfo": "Jumlah: {amount} (anggaran {clicks} klik). Lengkapkan pembayaran dengan butang PayPal di bawah.",
  "panel.back": "← Kembali",

  "panel.bmcWarningTitle": "⚠️ Sebelum anda meneruskan ke BuyMeCoffee:",
  "panel.bmcWarningBody":
    "Tampalkan kod di bawah ke dalam ruangan mesej/nota semasa checkout — itulah satu-satunya cara kami tahu negara mana yang anda sokong. Tanpa kod tersebut, kami tidak dapat mengaitkan pembayaran dengan mana-mana negara.",
  "panel.copy": "Salin",
  "panel.copied": "Disalin ✓",
  "panel.suggestedAmount": "Jumlah yang dicadangkan:",
  "panel.bmcAmountNote":
    "(anggaran {clicks} klik). Malangnya BuyMeCoffee tidak menyokong pembawaan jumlah melalui pautan — masukkan/pilih sendiri di laman mereka. Kiraan klik sebenar sentiasa dikira daripada jumlah yang benar-benar anda hantar di BuyMeCoffee, bukan daripada anggaran ini.",
  "panel.openBmc": "Buka BuyMeCoffee dan teruskan →",
  "panel.waitingProvider": "Menunggu pengesahan pembayaran daripada penyedia pembayaran …",
  "panel.waitingConfirmation": "Menunggu pengesahan pembayaran …",
  "panel.timedOut":
    "Semakan tamat masa. Jika anda telah melengkapkan pembayaran, peta akan dikemas kini sebaik sahaja pelayan menerima pengesahan - ini kadangkala mengambil sedikit masa lagi.",
  "panel.checkAgain": "Semak lagi",

  "panel.cancelled": "Pembayaran dibatalkan atau tidak berjaya. Peta tidak berubah.",
  "panel.tryAgain": "Cuba lagi",

  "panel.confirmed": "✅ Sokongan disahkan!",
  "panel.confirmedBody": "{country} menerima {clicks} klik berbayar bernilai {amount}.",

  "panel.errorPreparingSupport": "Ralat semasa menyediakan sokongan anda.",
  "panel.errorPreparingPayment": "Ralat semasa menyediakan pembayaran.",
  "panel.errorConfirmingPayment": "Ralat semasa mengesahkan pembayaran.",
  "panel.errorPayingPaypal": "Ralat semasa membayar dengan PayPal.",

  "share.unranked": "{flag}{country} memerlukan sokongan anda di peta dunia!\nBantu ia naik dalam papan pendahulu 👇",
  "share.rank1": "{flag}{country} kini berada di #1!\nBantu kami kekal di puncak 👇",
  "share.rankN": "{flag}{country} kini berada di #{rank}!\nBantu kami mencapai #1 👇",

  "language.switcherLabel": "Bahasa",
};

export default ms;
